import { render, staticRenderFns } from "./blogList.vue?vue&type=template&id=45d3f5fa&scoped=true"
import script from "./blogList.vue?vue&type=script&lang=js"
export * from "./blogList.vue?vue&type=script&lang=js"
import style0 from "./blogList.vue?vue&type=style&index=0&id=45d3f5fa&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d3f5fa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/www/prod-cn-snote-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45d3f5fa')) {
      api.createRecord('45d3f5fa', component.options)
    } else {
      api.reload('45d3f5fa', component.options)
    }
    module.hot.accept("./blogList.vue?vue&type=template&id=45d3f5fa&scoped=true", function () {
      api.rerender('45d3f5fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/blog/blogList.vue"
export default component.exports